import { useUserId } from '~hooks/useUserId';
import { useGetGenerationImagesSettingsQuery } from '~services/api/generation/endpoints';

export const useGetGenerationImagesSettings = () => {
	const userId = useUserId();

	return useGetGenerationImagesSettingsQuery({ userId }, { skip: !userId });
};
